import React from "react";
import { Icon } from "./Icon";

interface Facebook32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Facebook32: React.FC<Facebook32Props> = ({
  size,
  className,
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M627.2 233.6h102.4v-150.4h-150.4c-140.8 0-172.8 73.6-172.8 195.2v86.4h-108.8v147.2h108.8v428.8h160v-428.8h147.2l16-147.2h-160v-73.6c-0-38.4 3.2-57.6 57.6-57.6z" />
    </Icon>
  );
};
